module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec02_sp_cb03b3ff0fa44eefb55e495caa405b52.jpg";